import { render, staticRenderFns } from "./Citizenship.vue?vue&type=template&id=5f241a9f&"
import script from "./Citizenship.vue?vue&type=script&lang=js&"
export * from "./Citizenship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Citizenship.vue"
export default component.exports